exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.headerNavigation {\n  padding: 0;\n}\n.headerNavigation .item {\n    display: inline-block;\n    margin-right: 10px;\n}\n.headerNavigation .items-navig {\n    color: #2c3e50;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 0.6875rem;\n    padding: 8px 20px 9px 20px;\n    text-align: center;\n    -webkit-transition: background-color, color;\n    transition: background-color, color;\n}\n.headerNavigation .items-navig:hover {\n      border-radius: 16px;\n      background-color: #387d7a;\n      color: #ffffff;\n      -webkit-transition-duration: 0.5s, 0.2s;\n              transition-duration: 0.5s, 0.2s;\n}\n.headerNavigation .active-item {\n    border-radius: 16px;\n    background-color: #387d7a;\n    color: #ffffff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b6f52d4","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/generics/Navigation.vue
// module id = xHmt
// module chunks = 15